import { useEffect, type ReactNode } from 'react';
import { getAnalyticsService } from '@src/container';
import { analyticsConfig } from '@src/shared/constants/analytics.config';
import { usePageTracking } from '@src/presentation/hooks/analytics';
import { AnalyticsUserTracker } from './AnalyticsUserTracker';

interface AnalyticsProviderProps {
    children: ReactNode;
}

/**
 * Analytics Provider Component
 * Initializes Google Analytics and tracks page views
 */
export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
    // Initialize analytics on mount
    useEffect(() => {
        const analyticsService = getAnalyticsService();

        if (analyticsConfig.measurementId) {
            analyticsService.initialize({
                measurementId: analyticsConfig.measurementId,
                enabled: analyticsConfig.enabled,
                debug: analyticsConfig.debug,
                testMode: analyticsConfig.testMode,
                options: analyticsConfig.options,
            }).catch((error) => {
                console.error('Failed to initialize analytics:', error);
            });
        } else if (analyticsConfig.debug) {
            console.warn('Google Analytics measurement ID not configured. Set VITE_GA_MEASUREMENT_ID in your .env file.');
        }
    }, []);

    // Track page views on route changes
    usePageTracking();

    return (
        <>
            <AnalyticsUserTracker />
            {children}
        </>
    );
}
